import { defineStore } from 'pinia'
import {
  reactive,
  readonly,
  toRefs,
} from 'vue'
import type { License } from '~domain/License'


export const useLicenseStore = defineStore('license', () => {
  const state = reactive({
    license: undefined as License | undefined,
  })

  const actions = {
    setLicense (license?: License) {
      state.license = license
    },

    setState (params: Partial<typeof state>): void {
      Object.assign(state, params)
    },
  }

  return {
    ...toRefs(readonly(state)),
    ...actions,
  }
})
